import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import NotFound from "../../../notFound/NotFound";
import { BigHeadline } from "../../../../components/TextParts";
import { themeOptions } from "../../../../style/themeOptions";
import UserRegisterForm from "../organisms/UserRegisterForm";

const apptheme = createTheme(themeOptions);

export default function UserRegister() {
  const adminFlag = localStorage.getItem("adminFlag");
  const isValidAdmin = adminFlag !== null && Number(adminFlag) !== -1;

  if (!isValidAdmin) {
    return <NotFound />;
  }

  return (
    <Box sx={{ bgcolor: "#F2F3F4" }}>
      <ThemeProvider theme={apptheme}>
        <Box sx={{ flexGrow: 1 }}>
          <BigHeadline text="ユーザ追加" />
          <UserRegisterForm />
        </Box>
      </ThemeProvider>
    </Box>
  );
}